import React from 'react';
import SupportIcon from '../../assets/Icons/SupportIcon.svg?react';
import FAQContent from '../../containers/FAQPage/FAQContent';
import V2Layout from '../components/V2Layout';
import useV2Auth from '../hooks/useV2Auth';

const MANAGER_TELEGRAM_URL = 'https://t.me/fishh_support';

const V2FAQ: React.FC = () => {
  const { user } = useV2Auth();
  const [compact, setCompact] = React.useState(false);

  return (
    <V2Layout
      activeNav="faq"
      compact={compact}
      onToggleCompact={() => setCompact((value) => !value)}
      userEmail={user?.email}
      breadcrumbs={
        <p className="breadcrumbs">
          FAQ <span>/</span> <strong>Справка</strong>
        </p>
      }
      footerNote="FAQ"
    >
      <section className="player-heading player-heading--page">
        <div>
          <div className="player-title-line">
            <h1>FAQ</h1>
          </div>
          <p className="profile-description">
            Ответы на частые вопросы по статистике, режимам и интеграциям
          </p>
        </div>
      </section>

      <section className="faq-section" aria-label="Частые вопросы">
        <FAQContent embedded />
      </section>

      <section className="subscription-cta faq-support-cta">
        <span className="subscription-cta__icon" aria-hidden="true">
          <SupportIcon />
        </span>
        <div>
          <h2>Нужна помощь?</h2>
          <p className="body-text">
            Напишите менеджеру в Telegram — поможем с настройкой расширения, автопастом и
            интеграциями.
          </p>
        </div>
        <a className="acid-button" href={MANAGER_TELEGRAM_URL} target="_blank" rel="noreferrer">
          @fishh_support <span aria-hidden="true">↗</span>
        </a>
      </section>
    </V2Layout>
  );
};

export default V2FAQ;
